import { Component, Input, OnInit } from '@angular/core';

export interface StatusHistoryItem {
  date: Date;
  userName: string;
  status: number;
  statusTranslationKey: string;
  statusColorClass: string;
  comments?: string;
  [key: string]: any; // Permite propiedades adicionales
}

@Component({
  selector: 'app-status-history',
  templateUrl: './status-history.component.html',
  styleUrls: ['./status-history.component.scss']
})
export class StatusHistoryComponent implements OnInit {
  @Input() title: string = '$general.statusHistory';
  @Input() items: StatusHistoryItem[] = [];

  constructor() {}

  ngOnInit(): void {}
  
}
